import React, { Fragment } from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="text-center" role="timer" aria-label="Launch offer countdown" data-id="element-21" data-mp="3pzue6nd3dh7r">
      <p className="flex items-center justify-center gap-2 text-[13px] font-black uppercase tracking-wide text-navy sm:text-sm" data-id="element-22" data-mp="3c0b4hq4mtxtc">
        <ClockIcon className="h-4 w-4 text-coral" aria-hidden="true" data-id="element-23" data-mp="3gymeq1yuaac3" />
        My special launch offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-24" data-mp="372jdcybtafq7">
        {units.map((unit, i) => <Fragment key={unit.label} data-id="element-25" data-mp="10clc4kxpq8az" data-mpi={i}>
            {i > 0 && <span className="pt-4 font-display text-3xl font-bold text-navy" data-id="element-26" data-mp="10cv3ocyeonis">:</span>}
            <div className="flex flex-col items-center" data-id="element-27" data-mp="15a50ido4k1gn">
              <span className="grid h-[76px] w-[76px] place-items-center rounded-2xl bg-navy font-display text-[40px] font-bold tabular-nums text-white shadow-lg shadow-navy/20" data-id="element-28" data-mp="y0wvpooum2m2">
                {String(unit.value).padStart(2, '0')}
              </span>
              <span className="mt-1.5 text-[11px] font-extrabold uppercase tracking-wider text-muted" data-id="element-29" data-mp="17qgaai5j3ab4">{unit.label}</span>
            </div>
          </Fragment>)}
      </div>
      <p className="mt-3 inline-flex rounded-full bg-coral-soft px-3 py-1 text-xs font-black uppercase tracking-wide text-coral-dark" data-id="element-30" data-mp="f3dkqfity9x0">
        Limited-time launch price
      </p>
    </div>;
}